import React from 'react'
import { useOneClickPrescribeContext } from '../../context/OneClickPrescribeContext'
import { Skeleton } from 'antd'
import { StyledBadge } from './styles'

import { CaseTagEnum } from '../../../../types/enums'

import {
    HeaderContainer,
    HeaderLeft,
    Title,
    Subtitle,
    HeaderRight,
    ControlGroup,
    PillButton,
    PinInput,
} from './styles'

export const Menu = () => {
    const {
        categories,
        displayedCases,
        handleCategorySelect,
        getTelemedicineCategoryById,
        pin,
        handlePinChange,
        providerHasPinSet,
        loading,
        showFlaggedCases,
        setShowFlaggedCases,
        showLogs,
        setShowLogs,
    } = useOneClickPrescribeContext()

    const selectedCategory = categories?.selected
    const selectedCategoryData = selectedCategory ? getTelemedicineCategoryById(selectedCategory) : null
    const categoryName = selectedCategoryData?.name || 'Unknown Category'
    
    // Calculate counts from the Redux categories data
    const categoryCounts = categories?.all?.map(([categoryId, categoryData]) => {
        const category = getTelemedicineCategoryById(categoryId)
        const cases = categoryData.cases || []
        
        // Cleared cases are those with CLEAN_MIF tag
        const clearedCount = cases.filter(c => 
            c.tags?.includes(CaseTagEnum.CLEAN_MIF)
        ).length
        
        // Flagged cases are those WITHOUT CLEAN_MIF tag and haven't been acknowledged
        // This includes cases with FLAGGED_MIF tag or no tag at all
        const flaggedCount = cases.filter(c => 
            !c.tags?.includes(CaseTagEnum.CLEAN_MIF) && !c.tags?.includes('acknowledged')
        ).length
        
        return {
            categoryId,
            name: category?.name || 'Unknown',
            clearedCount,
            flaggedCount,
        }
    }) || []

    // Get counts for the selected category
    const selectedCategoryCounts = categoryCounts.find(c => c.categoryId === selectedCategory)
    const clearedCaseCount = selectedCategoryCounts?.clearedCount || 0
    const flaggedCaseCount = selectedCategoryCounts?.flaggedCount || 0

    // Get unique categories from available cases
    const availableCategories = categories?.all || []

    return (
        <HeaderContainer>
            <HeaderLeft>
                <Title>Clinical Review Queue</Title>
                <Skeleton loading={loading} paragraph={{ rows: 0 }}>
                    <Subtitle>
                        {clearedCaseCount} patient{clearedCaseCount !== 1 ? 's' : ''} awaiting review for {categoryName} program
                    </Subtitle>
                </Skeleton>
            </HeaderLeft>
            <HeaderRight>
                {/* PROGRAM SELECTOR */}
                {availableCategories.length > 0 && (
                    <ControlGroup>
                        {availableCategories.map(([categoryId]) => {
                            const counts = categoryCounts.find(c => c.categoryId === categoryId)
                            return (
                                <PillButton
                                    key={categoryId}
                                    $active={selectedCategory === categoryId}
                                    onClick={() => handleCategorySelect(categoryId)}
                                >
                                    {counts?.name || 'Unknown'}
                                    <StyledBadge count={counts?.clearedCount || 0} />
                                </PillButton>
                            )
                        })}
                    </ControlGroup>
                )}

                {/* FILTERS */}
                <ControlGroup>
                    <PillButton
                        $active={!showFlaggedCases && !showLogs}
                        onClick={() => { setShowFlaggedCases(false); setShowLogs(false); }}
                    >
                        Cleared
                    </PillButton>
                    <PillButton
                        $active={showFlaggedCases && !showLogs}
                        onClick={() => { setShowFlaggedCases(true); setShowLogs(false); }}
                    >
                        Flagged
                        <StyledBadge count={flaggedCaseCount} />
                    </PillButton>
                    <PillButton
                        $active={showLogs}
                        onClick={() => { setShowLogs(true); setShowFlaggedCases(false); }}
                    >
                        Logs
                    </PillButton>
                </ControlGroup>

                {/* PIN INPUT */}
                <PinInput
                    type="password"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="PIN"
                    value={pin}
                    onChange={handlePinChange}
                    disabled={!providerHasPinSet}
                    maxLength={4}
                    required
                />
            </HeaderRight>
        </HeaderContainer>
    )
}
